import React, { useState } from 'react';
import Checkbox from '../../components/Checkbox';

const Debt = ({ isChecked, description, onChange }) => {
	return (
		<Checkbox label={description} checked={isChecked} onChange={onChange}/>
	);
};

export default Debt;
